import { render } from "./Clock.vue?vue&type=template&id=572f4e1b"
import script from "./Clock.vue?vue&type=script&lang=js"
export * from "./Clock.vue?vue&type=script&lang=js"
script.render = render

export default script